// The app icon: a disc with three bars (the "country" columns of a stat chart).
export function AppIcon({ label }: { label: string }) {
    return (
        <svg className="app-icon" viewBox="0 0 192 192" role="img" aria-label={label}>
            <circle cx="96" cy="96" r="76" fill="var(--fg)" />
            <g fill="var(--bg)">
                <rect x="70" y="64" width="17" height="62" />
                <rect x="91" y="94" width="13" height="32" />
                <rect x="108" y="78" width="16" height="48" />
            </g>
        </svg>
    );
}
